export default {
  OVERVIEW: 'OVERVIEW',
  APPOINTMENTS: 'APPOINTMENTS',
  ADD_APPOINTMENT: 'ADD_APPOINTMENT',
  VIEW_APPOINTMENT: 'VIEW_APPOINTMENT',
  // TREATMENT: 'TREATMENT',
  FILES: 'FILES',
  FILES_SUMMARY: 'FILES_SUMMARY',
  VIEW_CASE_INFORMATION: 'VIEW_CASE_INFORMATION',
  ADD_CASE_INFORMATION: 'ADD_CASE_INFORMATION',
  ADD_TRACKING: 'ADD_TRACKING',
  VIEW_TRACKING: 'VIEW_TRACKING',
  REVIEW_TRACKING_DETAILS: 'REVIEW_TRACKING_DETAILS',
  SETUP_TREATMENT_PLAN: 'SETUP_TREATMENT_PLAN',
  VIEW_TREATMENT_PLAN: 'VIEW_TREATMENT_PLAN',
  CLEAR_ALIGNERS: 'CLEAR_ALIGNERS',
  ALIGNERS_TRACKING: 'ALIGNERS_TRACKING',
  VIEW_ALIGNER_CHANGES: 'VIEW_ALIGNER_CHANGES',
  ALIGNER_CHANGE_DETAILS: 'ALIGNER_CHANGE_DETAILS',
  WEAR_STATS: 'WEAR_STATS',
  SETUP_TREATMENT_PLAN_BRACES: 'SETUP_TREATMENT_PLAN_BRACES',
  VIEW_TREATMENT_PLAN_BRACES: 'VIEW_TREATMENT_PLAN_BRACES',
  TIMELINE: 'TIMELINE',
  PAYMENTS: 'PAYMENTS',
  PAYMENT_REMINDERS: 'PAYMENT_REMINDERS',
  LEADS: 'LEADS',
  ALIGNERS: 'ALIGNERS',
  ARCHIVE: 'ARCHIVE',
  COMPLETED: 'COMPLETED',
  BRACES_LIST: 'BRACES_LIST',
  BRACES_NOTES: 'BRACES_NOTES',
  ORDERS: 'ORDERS',
  TREATMENT_STARTED_INTRO: 'TREATMENT_STARTED_INTRO',
  PRODUCTION_BATCH_DETAILS: 'PRODUCTION_BATCH_DETAILS',
} as const
